/* eslint-disable no-console */
import { LoggerErrorMessage, LoggerExtraArgs, LoggerMessage } from './logger.types';

export const logger = {
  debug: (message: LoggerMessage, ...args: LoggerExtraArgs) => {
    console.debug(message, ...args);
  },

  info: (message: LoggerMessage, ...args: LoggerExtraArgs) => {
    console.info(message, ...args);
  },

  error: (message: LoggerErrorMessage, ...args: LoggerExtraArgs) => {
    console.error(message, ...args);
  },

  warn: (message: LoggerMessage, ...args: LoggerExtraArgs) => {
    console.warn(message, ...args);
  },
};
